import { StyleSheet } from "@react-pdf/renderer";
import { theme } from "../../styles/styles";

export const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: 'white',
    margin: 0
  },
  header: {
    backgroundColor: theme.voltBlue,
    height: '100px',
    color: 'white',
    fontSize: 24,
    textAlign: 'left',
    display: 'flex',
    flexDirection: 'row',
  },
  innerHeader: {
    backgroundColor: theme.voltBlue,
    borderWidth: 1,
    borderColor: theme.eLime,
    height: '75px',
    width: '100%',
    marginLeft: 50,
    marginBottom: 30,
    color: 'white',
    fontSize: 24,
    textAlign: 'left',
    borderRight: 0,
    borderTop: 0,
    padding: 10,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
  },
  logo: {
    width: 31,
    height: 50,
    marginLeft: 20,
    marginTop: 10,
  },
  mainPage: {
    width: '100%',
    padding: '20 50 0 50',
    marginBottom: 0,
    paddingBottom: 0,
  },
  titleText: {
    fontSize: 24,
    marginBottom: 10,
    color: theme.evTeal,
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: 10,
    borderWidth: 1,
    borderColor: theme.eLime,
    paddingLeft: 10,
    paddingRight: 10,
    paddingBottom: 0,
    marginBottom: 0,
    marginTop: 10,
  },
  gridItem: {
    padding: 15,
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderBottom: 0.5,
    borderColor: '#b3b3b3',
  },
  gridTitle: {
    fontSize: 14,
    color: theme.evTeal,
    marginBottom: 5,
  },
  gridIcon: {
    width: 20,
    height: 20,
    marginRight: 10,
  },
  gridValue: {
    fontSize: 14,
    color: theme.voltBlue,
  },
  incentiveContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    backgroundColor: theme.ecoMint,
    borderRadius: 8,
    width: '100%',
    padding: '15 15 15 15',
    marginBottom: 15,
    marginTop: 10,
  },
  incentiveTitle: {
    fontSize: 12,
    textDecoration: 'none',
    color: theme.voltBlue,
    fontWeight: 'bold',
    display: 'flex',
    marginBottom: 0,
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'space-between',
    paddingBottom: 5,
},
  incentiveBody: {
    fontSize: 11,
    color: theme.voltBlue,
    textAlign: 'left',
    display: 'block',
    paddingLeft: 10,
    bold: {
      fontWeight: 'bold',
      color: theme.evTeal,
    }
  },
  incentiveBodyLine: {
    color: theme.voltBlue,
    textAlign: 'left',
    display: 'block',
    paddingBottom: 4
  },
  linkStyle: {
    fontSize: 13,
    textDecoration: 'none',
    color: theme.voltBlue,
    fontWeight: 'bold',
    display: 'flex',
    marginBottom: 0,
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'space-between',
    padding: '0 5 5 5',
    hover: {
      color: theme.evTeal,
      cursor: 'pointer',
    },
  },
  calculationSection: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '95%',
    borderBottom: 0.5,
    borderColor: theme.voltBlue,
  },
  calculationTitle: {
    width: '28%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'left',
    justifyContent: 'center',
    height: '100%',
  },
  calculationList: {
    width: '72%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  calculationTitleText: {
    fontSize: 20,
    color: theme.evTeal,
    marginBottom: 10,
  },
  calculationNumber: {
    fontSize: 14,
    color: theme.evTeal,
    textAlign: 'right',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'center'
  },
  calculationLabel: {
    fontSize: 14,
    color: theme.evTeal,
    textAlign: 'left',
    paddingRight: 10,
    marginRight: 10,
    width: '90%',
    display: 'flex',
    flexDirection: 'column',
  },
  boldText: {
    fontWeight: 'bold',
    color: theme.evTeal,
  },
  advancedConfigGrid: {
    display: 'grid',
    gridTemplateColumns: '3fr 1fr 1fr 1fr 3fr',
    gap: 1,
    borderWidth: 1,
    borderColor: theme.eLime,
    marginBottom: 0,
    marginTop: 10,
    padding: 10,
  },
  advancedConfigGridItem: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderTop: 0.5,
    borderColor: '#b3b3b3'
  },
  advancedConfigBox: {
    display: 'flex',
    flexDirection: 'column',
    fontSize: 11,
    width: '100%',
    height: '100%',
    backgroundColor: 'white',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    padding: 10,
    borderLeft: 0.5,
    borderColor: '#b3b3b3',
  },
  subheader: {
    fontSize: 14,
    color: theme.voltBlue,
    marginTop: 5,
  },
});